export const BYTES = 1024;
